// export function splitTextIntoParagraphs(text) {
//   const paragraphs = text.split("\n");
//   return paragraphs;
// }

export function splitTextIntoParagraphs(text) {
  const MIN_PARAGRAPH_LENGTH = 25;
  const paragraphs = [];
  let currentParagraph = "";

  for (let i = 0; i < text.length; i++) {
    const char = text.charAt(i);

    // If the current character is a line break, add the current paragraph to the output array
    // and start a new paragraph
    if (char === "\n") {
      if (currentParagraph.length >= MIN_PARAGRAPH_LENGTH) {
        paragraphs.push(currentParagraph);
      } else {
        // If the current paragraph is too short, combine it with the next paragraph
        const nextChar = text.charAt(i + 1);
        if (nextChar && nextChar !== "\n") {
          currentParagraph += char;
        }
      }
      currentParagraph = "";
    } else {
      currentParagraph += char;
    }
  }

  // Add any remaining text as the last paragraph
  if (currentParagraph.length >= MIN_PARAGRAPH_LENGTH) {
    paragraphs.push(currentParagraph);
  } else if (paragraphs.length > 0) {
    // If the last paragraph is too short, combine it with the second-to-last paragraph
    const lastParagraph = paragraphs.pop();
    const combinedParagraph = lastParagraph + currentParagraph;
    paragraphs.push(combinedParagraph);
  }

  return paragraphs;
}
